import React from 'react';
import MaterialForm from 'components/frank/MaterialForm.jsx';
import UserUnitPriceCreateForm from 'components/quote_builder/UserUnitPriceCreateForm.jsx';
import AddMachineFlow from 'components/frank/AddMachineFlow.jsx';

// The forms the guided setup wizard renders for its OWN-lines setup steps -- one per missing prerequisite, each a
// discrete counted stage (see setupWizardStages.js). A machine is TWO steps: MachineEntryStep adds the machine
// record, MachinePriceStep prices it. Completing any step calls onResolved -- the wizard's re-solve, which
// refreshes the counts AND forces the wizard to recompute -- so the now-satisfied step drops and the wizard
// advances. Completing a step IS how you move on, and the "Step X of N" total shrinks as prerequisites are met.

// ADD A MATERIAL PRICE. The list leads with the "frequently used" system materials (Seç ve fiyat ekle -> just
// enter your price), with the full create form for anything else -- the same material adder the inline empty
// state shows. No bobbin default is seeded here (the inline adder takes it from the live filter island): this
// material step comes BEFORE the line step where Bobin is chosen, so there is no section bobbin state yet, and
// the form uses its own default -- the owner sets Bobin on the material itself.
export const MaterialPriceStep = ({ materialKey, onResolved }) => (
  <MaterialForm materialKey={materialKey} systemItemsFirst afterSave={onResolved} />
);

// ADD THE MACHINE ITSELF (not its price -- that is the next step). Reuses AddMachineFlow in entryOnly mode: the
// curated library picker (or "enter manually") creates the machine and finishes the step, without falling into
// its price form. onResolved then re-solves, which drops this step and advances the wizard onto pricing the
// machine. Reusing AddMachineFlow keeps the pick/manual-entry flow in ONE place rather than a second copy here.
export const MachineEntryStep = ({ machineKey, allowedTypes, onResolved }) => (
  <AddMachineFlow
    machineKey={machineKey}
    allowedTypes={allowedTypes}
    entryOnly
    onCopied={onResolved}
    onPriced={() => {}}
    onClose={() => {}}
  />
);

// ADD THE MACHINE'S PRICE. The price form opens on a new record with the machine field auto-selecting the
// owner's existing (unpriced) machine of this type -- no attributeId, so no context (see UserUnitPriceCreateForm).
// This is the reported case: the machine is there, only its price is missing. The form shows NO buttons of its
// own (hideButtons) -- the wizard's Next saves it through submitRef, its Back cancels -- and on save onResolved
// re-solves, which drops this step and advances.
export const MachinePriceStep = ({ machineKey, submitRef, onSaveError, onResolved }) => (
  <UserUnitPriceCreateForm
    priceKey={machineKey}
    contextKey={machineKey}
    afterSave={onResolved}
    hideButtons
    submitRef={submitRef}
    onSaveError={onSaveError}
  />
);
